export default {
  "b2b.zadost-detail.title": "Request {id}",
  "b2b.zadost-detail.not-found": "Request {id} not found"
};
